<template>
  <export-pdf :loading="loading" filename="dashboard_clube" title="Dashboard do Clube" :subtitle="subtitle">
    <mf-pdf-item title="Métricas do Dashboard" :name="$getLoggedUser().client">
      <dashboard-metrics :metrics="dashboardCardsMetrics" />
    </mf-pdf-item>
  </export-pdf>
</template>

<script>
import ExportPdf from '@/components/ExportPdf.vue'
import DashboardMetrics from './DashboardMetrics.vue'
import { DateTime } from 'luxon'

export default {
  name: 'DashboardPdf',
  components: {
    ExportPdf,
    DashboardMetrics,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    dashboardCardsMetrics: {
      type: Array,
      default: () => [],
    },
    filters: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    dateSubtitle() {
      if (!this.filters?.data) {
        return null
      }

      const startDate = this.filters.data[0]
      const endDate = this.filters.data[1]

      const formattedStartDate = DateTime.fromFormat(startDate, 'yyyy-MM-dd').toFormat('dd/MM/yyyy')
      const formattedEndDate = DateTime.fromFormat(endDate, 'yyyy-MM-dd').toFormat('dd/MM/yyyy')

      return `Período: ${formattedStartDate} a ${formattedEndDate}`
    },
    segmentsSubtitle() {
      const segments = this.filters?.segmentsObjects

      if (!segments || !Array.isArray(segments) || segments.length === 0) {
        return null
      }

      const segmentNames = segments.map((segment) => segment.name || segment).join(', ')

      return `Segmentos: ${segmentNames}`
    },
    unitsSubtitle() {
      const selectedUnits = this.filters?.units

      if (!selectedUnits || !Array.isArray(selectedUnits) || selectedUnits.length === 0) {
        return null
      }
      return `${selectedUnits.length} lojas selecionadas`
    },
    subtitle() {
      const subtitleParts = []

      if (this.dateSubtitle) {
        subtitleParts.push(this.dateSubtitle)
      }

      if (this.segmentsSubtitle) {
        subtitleParts.push(this.segmentsSubtitle)
      }

      if (this.unitsSubtitle) {
        subtitleParts.push(this.unitsSubtitle)
      }

      if (subtitleParts.length === 0) {
        return 'Dashboard do Clube'
      }

      return subtitleParts.join(' | ')
    },
  },
}
</script>

<style lang="scss">
h2 {
  font-size: 16px !important;
}
</style>
